




































import { Component, Mixins } from 'vue-property-decorator'
import { findTracksWithMissingParenthesis, addMixParenthesis } from '@/helpers/features/smartfixes/add-mix-parenthesis'
import { Track } from '@/classes/track'
import { IColumnDef } from '@/interfaces/ag-grid'
import { LibraryMixin } from '@/mixins'
import { TrackFields } from '@/constants'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { ITransformerSettings, TRANSFORMERS } from '@/helpers/transformer'
import { waitForMinimumDelay } from '@/helpers/date'

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default,
    SmartFix: require('./SmartFix').default
  }
})
export default class AddMixParenthesis extends Mixins(LibraryMixin) {
  scanned: boolean = false
  loading: boolean = false
  tracks: Track[] = []
  selectedTracks: Track[] = []

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title
    },
    {
      field: 'New Title',
      width: 150,
      valueGetter: (params: any) => {
        return addMixParenthesis(params.data, [TrackFields.Title])
      }
    }
  ]

  get disabled(): boolean {
    return this.selectedTracks.length === 0
  }

  async scan() {
    if (this.loading || this.scanned) return

    this.loading = true

    const startTime = new Date()

    this.tracks = findTracksWithMissingParenthesis(this.library.tracks)

    await waitForMinimumDelay(startTime, 500)

    this.loading = false
    this.scanned = true

    window.addUsageStat(USAGE_STAT_FEATURES.SmartFix, 'add mix parenthesis', 'scan')
  }

  async confirm() {
    if (this.loading || this.selectedTracks.length === 0) return

    this.loading = true

    const transformer: TRANSFORMERS = TRANSFORMERS.CustomFunction
    const settings: ITransformerSettings = { function: addMixParenthesis, values: [TrackFields.Title] }

    try {
      await this.$store.dispatch('transformer/execute', {
        tracks: this.selectedTracks,
        transformer,
        settings
      })

      this.$buefy.notification.open(`Parenthesis have been added`)

      window.addUsageStat(USAGE_STAT_FEATURES.SmartFix, 'add mix parenthesis', 'confirm')
    } catch (error) {
      console.error(error)

      if (this.$store.state.auth.isDemoUser) {
        this.$buefy.notification.open(`Parenthesis have been added`)
      }
    }

    this.loading = false
    this.scanned = false
    this.tracks = []
    this.selectedTracks = []
  }
}
